import React from 'react';
import successSvg from '../../assets/svg/result-success.svg';
import errorSvg from '../../assets/svg/result-error.svg';
import Button from '../../components/Button';
import { useStateContext } from '../../context/StateContext';
import { updateCurrentStepState } from '../../reducers/actions';
import { toFixedNoRounding } from '../../utils/helpers';
import { STEPS } from '../../utils/constants';
import style from './result.module.scss';

const Result = ({ onRedirect }) => {
	const millisecondsToWait = 3000;
	const { state: { resultData }, dispatch } = useStateContext();
	const redirectToFirstStep = () => {
		updateCurrentStepState({ payload: STEPS.OVERVIEW, dispatch });
		onRedirect && onRedirect();
	};

	setTimeout(function() {
		if(resultData?.contentCallBackMsg) {	
			window.location.href = resultData?.contentCallBackMsg + "&status=" + resultData?.status;
		}
	}, millisecondsToWait);

	if (!resultData?.status || resultData?.status === 'failure') {
		return (
			<>
				<div className={style.resultInfo}>
					<img className={style.errorIcon} src={errorSvg} alt='error' />
					<h1>Ödeme başarısız</h1>
					<label>{resultData?.errorMessage || 'Bir hata oluştu.'}</label>

					<Button name='Tekrar öde' onClick={redirectToFirstStep} />
				</div>
			</>
		);
	}

	return (
		<>
			<div className={style.resultInfo}>
				<img src={successSvg} alt='success' />
				<h1>Ödeme başarılı</h1>
				<label>Kartınızdan {toFixedNoRounding(resultData?.paidPrice, 2)} TL başarı ile tahsil edilmiştir.</label>
			</div>
		</>
	);
};

export default Result;
